var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "sub_top"
  }, [_c('SubTitle'), _vm._m(0)], 1), _c('div', {
    staticClass: "ptc_container"
  }, [_c('div', {
    staticClass: "info_section"
  }, [_vm._m(1), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require(`@/style/new/images/info/overview_01.png`),
      "alt": ""
    }
  })])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub_tit"
  }, [_c('div', {
    staticClass: "sub_tit_inner"
  }, [_c('h2', [_vm._v("사업개요")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_txt"
  }, [_c('p', {
    staticClass: "txt_typ_1"
  }, [_vm._v("공유·활용체계를 구축하여 실시간으로 활용이 가능한 쉽고 원활한")]), _c('p', {
    staticClass: "txt_typ_2"
  }, [_c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("측정·분석기술")]), _c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("수집·관리·공유 서비스")])]), _c('hr', {
    staticClass: "hr_line"
  }), _c('p', {
    staticClass: "txt_typ_3"
  }, [_vm._v("연구자 개개인이 습득·보유하고 있는 고난도 측정·분석 노하우를 프로토콜하여 이를 "), _c('strong', [_vm._v("수집·축적 하여 공유·활용하고자 한다.")])]), _c('p', {
    staticClass: "txt_typ_3"
  }, [_vm._v(" 이는 확장성을 고려한 표준화 측정분석 프로토콜 플랫폼의 기반이 되고 이를 통해 "), _c('strong', [_vm._v("탐색설계 - 측정 분석-공정설계")]), _vm._v("로 이어지는 3대 국가소재연구데이터센터의 핵심적 역할을 수행할 것이다. ")])]);

}]

export { render, staticRenderFns }